<section class="comp-additional-info">

  <app-data-table [columns]="additionalInfosColumns" [value]="additionalInfos" sortField="columnName" [sortOrder]="PrimeNgConfig.TableAscSortOrder"
                  [rightCaptionTemplate]="rightCaptionTemplate">

    <ng-template #rightCaptionTemplate>
      <button pButton type="button" class="action-secondary" icon="fa fa-plus" label="Info"
              (click)="onClickShowAdditionalInfo()"
              [disabled]="additionalInfos.length > 0 && additionalInfos.length===backupAdditionalInfos.length && backupAdditionalInfos.length > columnNameDropdown.length">
      </button>
    </ng-template>

    <ng-template #actionTemplate let-row="row">
      <button pButton type="button" class="icon-button icon-action" icon="fa fa-pencil" (click)="onClickEditAdditionalInfo(row)">
      </button>
      <button pButton type="button" class="icon-button icon-negative" icon="fa fa-trash" (click)="onClickDeleteAdditionalInfo(row)">
      </button>
    </ng-template>

  </app-data-table>

  <!-- dialog for adding Additional Info -->
  <p-dialog *ngIf="additionalInfoToEdit&&displayDialog" [(visible)]="displayDialog"
            header="Add/Edit Info" [responsive]="true" [modal]="true" [style]="PrimeNgConfig.DialogStyle40">
    <form #dialogForm="ngForm">

      <div class="p-grid">
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Column Name </label>
        </div>
        <div class="p-col-12 p-md-8 p-lg-8">
          <p-dropdown *ngIf="newAdditionalInfo"
                      name="colName" [placeholder]="PrimeNgConfig.DropdownPlaceholder"
                      [options]="columnNameDropdown"
                      [(ngModel)]="additionalInfoToEdit.columnId"
                      (onChange)="onChangeColumnName($event)" required></p-dropdown>
          <span *ngIf="!newAdditionalInfo">{{additionalInfoToEdit.columnName}} </span>
        </div>
        <div class="p-col-12 p-md-4 p-lg-4">
          <label>Value * </label>
        </div>
        <div class="p-col-12  p-md-8 p-lg-8">
          <input pInputText name="value" type="text" [maxlength]=Validation.AdditionalInfoMaxLength
                 [(ngModel)]="additionalInfoToEdit.columnValue" required></div>

      </div>
    </form>
    <p-footer>
      <div style="float:right;text-align:right;width:100%;margin:15px;">
        <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel"
                (click)="onClickCancelAdditionalInfo()"></button>
        <button *ngIf="newAdditionalInfo" pButton type="button" class="button-action" icon="fa fa-check" label="Add"
                (click)="onClickAddAdditionalInfo(additionalInfoToEdit)"
                [disabled]="!dialogForm.form.valid"></button>
        <button *ngIf="!newAdditionalInfo" pButton type="button" class="button-action" icon="fa fa-check" label="Update"
                (click)="onClickUpdateAdditionalInfo(additionalInfoToEdit)"
                [disabled]="!dialogForm.form.valid">
        </button>

      </div>
    </p-footer>
  </p-dialog>

  <p-confirmDialog></p-confirmDialog>

</section>
